import { 
  Home, BookOpen, BookText, FileText, 
  FileSpreadsheet, MessageSquare,
  Users, Building, Calendar, Settings,
  Building2, PieChart, RefreshCw, Activity
} from 'lucide-react';

// Navigation principale - Flux comptable
export const navigation = [
  { 
    name: 'Tableau de Bord', 
    icon: Home, 
    path: '/',
    badge: null
  },
  { 
    name: 'Journaux', 
    icon: BookOpen, 
    path: '/journals',
    badge: null
  },
  { 
    name: 'Grand Livre', 
    icon: BookText, 
    path: '/ledger',
    badge: null
  },
  { 
    name: 'États Financiers', 
    icon: FileText, 
    path: '/reports',
    badge: null
  },
  { 
    name: 'Déclarations', 
    icon: FileSpreadsheet, 
    path: '/declarations',
    badge: null
  },
  { 
    name: 'Immobilisations', 
    icon: Building2, 
    path: '/fixed-assets',
    badge: null
  },
  { 
    name: 'Analytique', 
    icon: PieChart, 
    path: '/analytic-accounting',
    badge: null,
    frameworkOnly: ['SYSCOHADA_NORMAL', 'IFRS'] as string[]
  },
  { 
    name: 'Récurrences', 
    icon: RefreshCw, 
    path: '/recurring-entries',
    badge: null
  },
];

// Navigation secondaire - Gestion
export const secondaryNavigation = [
  { 
    name: 'Exercices', 
    icon: Calendar, 
    path: '/fiscal-years'
  },
  { 
    name: 'Entreprise', 
    icon: Building, 
    path: '/organization'
  },
  { 
    name: 'Utilisateurs', 
    icon: Users, 
    path: '/users'
  },
  {
    name: 'Logs d\'activité',
    icon: Activity,
    path: '/activity-logs'
  },
  { 
    name: 'Paramètres', 
    icon: Settings, 
    path: '/settings'
  },
] as const;

// Assistant IA
export const assistantNavigation = [
  { 
    name: 'Assistant Compta', 
    icon: MessageSquare, 
    path: '/chat',
    badge: { text: 'IA', color: 'bg-purple-500' }
  },
] as const;